import React, { useEffect } from "react";

export default function SmiJs(props) {
    useEffect(() => {
        
        (function() {
            var sm = document.createElement("script");
            sm.type = "text/javascript";
            sm.async = true;
            sm.src = "//jsn.24smi.net/smi.js";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(sm, s);
        })();

        (window.smiq = window.smiq || []).push({});

    }, []);

    return null;
}
